import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'
import cloneDeep from 'lodash/cloneDeep'

export interface IItpListQueryPaginationPayload {
    pagination?: PaginationType
    query?: any
    needPopulate?: boolean
    necessaryProjectionArray?: string[]
    populates?: any[]
    sagaCB?: {
        onSuccess: any
    }
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const itpListSlice = createSlice({
    name: 'hub/companies/itp-list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IItpListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onChangeItem(state, action) {
            const newData = cloneDeep(state.data)
            const item = newData.find(item => item._id === action.payload.id)
            Object.keys(action.payload.data).map(key => {
                item[key] = action.payload.data[key]
            })
            if (action.payload.data.status === 'Active') {
                newData
                    .filter(itpItem => itpItem._id !== item._id)
                    .forEach(itpItemp => {
                        itpItemp.status = 'Inactive'
                    })
            }
            state.data = newData
        },
        onDeleteItem(state, action) {
            const newData = [...state.data].filter(item => item._id !== action.payload)
            state.data = newData
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const itpListActions = itpListSlice.actions
export default itpListSlice.reducer
